import { CreateListingForm } from "../components/CreateListing/CreateListingForm"
import { Navbar } from "../components/Navbar"

const CreateListing = () => {
    return (
        <div className="min-h-screen flex flex-col">
            <Navbar />

            <main className="flex-1 pt-24 pb-16">
                <div className="container px-4 mx-auto">
                    <div className="max-w-2xl mx-auto">
                        {/* Page Header */}
                        <div className="mb-8">
                            <h1 className="text-3xl font-bold mb-2">Create a New Listing</h1>
                            <p className="text-muted-foreground">
                                Share your homegrown food with your community. Provide details about what you're offering and what you'd like in return.
                            </p>
                        </div>

                        {/* Listing Form */}
                        <div className="bg-white p-6 rounded-xl border border-border/60 shadow-sm">
                            <CreateListingForm />
                        </div>
                    </div>
                </div>
            </main>

            {/* Footer */}
            <footer className="bg-igbanwo-mint/5 p-8 border-t border-border/60">
                <div className="container px-4 mx-auto text-center text-sm text-muted-foreground">
                    &copy; {new Date().getFullYear()} Thoreau Consulting (PTY) Ltd. All rights reserved.
                </div>
            </footer>
        </div>
    )
}

export default CreateListing